import PropTypes from 'prop-types';

import type { TextTypeValues } from './text-types';

export type { TextTypeValues };

export const TextType: Record<TextTypeValues, TextTypeValues> = {
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  Label: 'Label',
  Description: 'Description',
  Paragraph: 'Paragraph',
  Caption: 'Caption',
};

export const TextTypePropType = PropTypes.oneOf(Object.values(TextType));
